export { View as PoluchiteBezBankov } from './view'
